import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { BrowserTranslationGuardService } from "../../../services/browser-translation-guard.service";
import { TopBannerRowComponent } from "../top-banner/top-banner-row.component";
import { TopBannerShellComponent } from "../top-banner/top-banner-shell.component";

@Component({
  selector: "app-browser-translation-banner",
  standalone: true,
  imports: [
    TranslatePipe,
    TopBannerShellComponent,
    TopBannerRowComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./browser-translation-banner.component.html",
})
export class BrowserTranslationBannerComponent implements OnInit {
  private readonly guard = inject(BrowserTranslationGuardService);

  readonly visible = this.guard.warningVisible;

  ngOnInit(): void {
    this.guard.startMonitoring();
  }

  dismiss(): void {
    this.guard.dismissForSession();
  }
}
